// Vẽ và bắt điểm chạm cho hình dán.
//
// Mô hình dữ liệu: hình dán được neo theo TÂM, không theo góc trên-trái.
// Nếu neo theo góc thì mỗi lần đổi kích thước hình sẽ nhảy vị trí, và xoay
// quanh tâm cũng không viết được gọn.
//
// {
//     id: 7,              // ID tăng dần — KHÔNG dùng chỉ số mảng
//     kind: "emoji",      // "emoji" | "image" | "text"
//     char: "🎀",         // với kind = emoji
//     src: "...",         // với kind = image
//     text: "26.08.02",   // với kind = text
//     color: "#ff7aa2",   // với kind = text
//     x: 600, y: 1500,    // TÂM của hình dán
//     size: 160,          // cạnh hộp bao
//     rotation: 0,        // radian
//     flipX: false
// }

export const EMOJI_FONT =
    '"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif';
export const TEXT_FONT = "Broline, cursive";

// Ảnh hình dán tải một lần rồi dùng mãi. Trước đây mỗi lần bấm là một
// `new Image()` mới nên cùng một hình dán bị tải lại nhiều lần.
const imageCache = new Map();

export const loadStickerImage = src => {
    const cached = imageCache.get(src);
    if (cached) return Promise.resolve(cached);

    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            imageCache.set(src, img);
            resolve(img);
        };
        img.onerror = reject;
        img.src = src;
    });
};

export const drawSticker = (ctx, s) => {
    ctx.save();
    ctx.translate(s.x, s.y);
    if (s.rotation) ctx.rotate(s.rotation);
    if (s.flipX) ctx.scale(-1, 1);

    if (s.kind === "image") {
        const img = imageCache.get(s.src);
        // Ảnh chưa tải xong thì bỏ qua khung hình này; lần vẽ sau sẽ có.
        if (img) ctx.drawImage(img, -s.size / 2, -s.size / 2, s.size, s.size);
    } else {
        ctx.font = `${s.size}px ${s.kind === "emoji" ? EMOJI_FONT : TEXT_FONT}`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = s.color || "#8c5b4a";
        ctx.fillText(s.kind === "emoji" ? s.char : s.text, 0, 0);
    }

    ctx.restore();
};

// Viền báo hình dán đang được chọn. Chỉ vẽ khi xem trên màn hình —
// bản xuất ra file phải gọi render({ forExport: true }) để bỏ viền này.
export const drawSelection = (ctx, s) => {
    const half = s.size / 2;

    ctx.save();
    ctx.translate(s.x, s.y);
    if (s.rotation) ctx.rotate(s.rotation);

    ctx.strokeStyle = "#ff7aa2";
    ctx.lineWidth = 4;
    ctx.setLineDash([14, 10]);
    ctx.strokeRect(-half, -half, s.size, s.size);

    ctx.restore();
};

// Bắt điểm chạm khi hình dán đã bị xoay: quay ngược điểm chuột về hệ toạ độ
// riêng của hình dán rồi mới so với hộp bao.
export const hitTestSticker = (s, x, y) => {
    const dx = x - s.x;
    const dy = y - s.y;

    const c = Math.cos(-s.rotation || 0);
    const sn = Math.sin(-s.rotation || 0);
    const lx = dx * c - dy * sn;
    const ly = dx * sn + dy * c;

    const half = s.size / 2;
    return lx >= -half && lx <= half && ly >= -half && ly <= half;
};

// Vị trí xuất hiện của hình dán mới. Trước đây luôn là (400, 100) cứng nên dán
// 5 cái chỉ thấy 1. Ở đây rải quanh tâm canvas theo lưới 5×5 rồi lặp lại.
export const nextStickerPosition = (canvasSize, count) => ({
    x: canvasSize.width / 2 + ((count % 5) - 2) * 70,
    y: canvasSize.height / 2 + ((Math.floor(count / 5) % 5) - 2) * 70
});

// Giữ tâm hình dán trong lòng canvas để không kéo mất hẳn ra ngoài.
export const clampStickerCenter = (canvasSize, x, y) => ({
    x: Math.min(Math.max(x, 0), canvasSize.width),
    y: Math.min(Math.max(y, 0), canvasSize.height)
});
